import { render } from "./ExternalSearchResultInfo.vue?vue&type=template&id=24ff0a1c&ts=true"
import script from "./ExternalSearchResultInfo.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchResultInfo.vue?vue&type=script&lang=ts"

import "./ExternalSearchResultInfo.vue?vue&type=style&index=0&id=24ff0a1c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__